import { FC } from 'react';
import './GeneralModal.css';
import React from 'react';
import { useTranslation } from 'react-i18next';

type GMVariant = 'default' | 'danger' | 'success' | 'warning';

interface Props {
  handleClose?: () => void;
  handleClick?: () => void;
  children: React.ReactNode;
  footerContent?: React.ReactNode;
  footerContentTop?: boolean;

  width?: string;
  minwidth?: string;
  radius?: string;
  height?: string;

  headerName: string;

  /** @deprecated - do not use raw colors; kept for backwards compatibility */
  headerColor?: string;

  /** NEW: token-based variant */
  variant?: GMVariant;

  isFullScreen?: boolean;
  hideHeader?: boolean;
  hideFooter?: boolean;
  footerActionsSpread?: boolean;
  cancelText?: React.ReactNode;
  confirmText?: React.ReactNode;
}

const GeneralModal: FC<Props> = (props: Props) => {
  const { i18n } = useTranslation();

  const {
    handleClick,
    handleClose,
    children,
    footerContent,
    footerContentTop = false,
    width,
    minwidth,
    radius,
    height,
    headerName,
    variant = 'default',
    isFullScreen,
    hideHeader,
    hideFooter,
    footerActionsSpread = false,
    headerColor,
    cancelText,
    confirmText
  } = props;

  return (
    <div className="gmOverlay" role="dialog" aria-modal="true">
      <div
        className={`gmContainer  ${isFullScreen ? 'isFullScreen' : ''}`}
        style={{
          ...(width ? ({ ['--gm-w' as any]: width } as React.CSSProperties) : {}),
          ...(minwidth ? ({ ['--gm-minw' as any]: minwidth } as React.CSSProperties) : {}),
          ...(height ? ({ ['--gm-h' as any]: height } as React.CSSProperties) : {}),
          ...(radius ? ({ ['--gm-r' as any]: radius } as React.CSSProperties) : {}),
        }}
      >
        {!hideHeader && (
          <div className={`gmHeader ${headerColor} is-${variant}`}>
            <h5 className="gmTitle">{headerName}</h5>
            <button type="button" className="gmClose" onClick={handleClose} aria-label="Close">
              ×
            </button>
          </div>
        )}

        <div className="gmBody">{children}</div>

        {!hideFooter && (
          <div className={`gmFooter ${isFullScreen ? 'isFull' : ''}`}>
            {footerContentTop && footerContent}
            <div className={`gmFooterActions ${footerActionsSpread ? 'isSpread' : ''}`}>
              <button type="button" className="gmBtn gmBtnGhost" onClick={handleClose}>
                {cancelText ?? i18n.t(`generic.cancel`)}
              </button>
              <button type="button" className="gmBtn gmBtnPrimary" onClick={handleClick}>
                {confirmText ?? i18n.t(`generic.approve`)}
              </button>
            </div>
            {!footerContentTop && footerContent}
          </div>
        )}
      </div>
    </div>
  );
};

export default GeneralModal;
